/* Shared table chrome for the /warehouse list pages: sort indicators,
   windowed pagination and loading placeholders. Each page keeps owning its
   own `sortState`, `currentPage`, `totalPages`, `totalCount` and `pageSize`. */

export const ELLIPSIS = '…'

/* Collapses a long page list down to `1 … 7 8 9 … 42`. */
export function buildPageRange(current, total, span = 1) {
  if (!total || total <= 1) return [1]

  const pages = new Set([1, total])
  for (let page = current - span; page <= current + span; page += 1) {
    if (page > 1 && page < total) pages.add(page)
  }
  // Pad the near edge so the strip keeps a stable width on page 1 and the last.
  if (current <= 2 + span) {
    for (let page = 2; page <= Math.min(total - 1, 2 + span * 2); page += 1) pages.add(page)
  }
  if (current >= total - 1 - span) {
    for (let page = Math.max(2, total - 1 - span * 2); page <= total - 1; page += 1) pages.add(page)
  }

  const sorted = [...pages].sort((a, b) => a - b)
  return sorted.reduce((out, page, index) => {
    if (index > 0 && page - sorted[index - 1] > 1) out.push(ELLIPSIS)
    out.push(page)
    return out
  }, [])
}

export default {
  data() {
    return { ellipsis: ELLIPSIS }
  },
  computed: {
    pageNumbers() {
      return buildPageRange(this.currentPage, this.totalPages)
    },
    skeletonRows() {
      return Math.min(this.pageSize || 8, 8)
    },
  },
  methods: {
    sortIcon(key) {
      if (this.sortState.key !== key) return '↕'
      return this.sortState.dir === 'asc' ? '▲' : '▼'
    },
    ariaSort(key) {
      if (this.sortState.key !== key) return 'none'
      return this.sortState.dir === 'asc' ? 'ascending' : 'descending'
    },
  },
}
